import { useLazyQuery, useMutation } from "@apollo/client";
import { UPDATE_TOKEN } from "../GraphQLModules/Login/mutation";
import HeaderComponent from "../Header";
import RouteProvider from "../Routing";
import { Suspense, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { constantData } from "../../../Assets/constants";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { useTheme } from "@emotion/react";
import Components from "../../../Components";
import { defineAbilitiesFor } from "../../../Assets/Library/Casl/ability";
import { GET_ACTIVE_TENANT_PRIVILEGES } from "../GraphQLModules/Login/queries";
import { AbilityContext } from "../../../Assets/Library/Casl/AbilityContext";
import NotificationProvider from "../Notifications/NotificationProvider";

const UpdateToken = ({ result, updatedToken }) => {
  const navigate = useNavigate();
  const [ability, setAbility] = useState(defineAbilitiesFor());
  const [privilegesFetched, setPrivilegesFetched] = useState(false);
  const [tenantId, setTenantId] = useState(null);
  const [getActiveTenantInfo] = useLazyQuery(GET_ACTIVE_TENANT_PRIVILEGES, {
    onError: () => { },
    onCompleted: (data) => {
      const actionObjects =
        data?.getActiveTenantPrivileges?.privilege_token.map((action) => ({
          action,
        }));
      const fetchedTenantId = data?.getActiveTenantPrivileges?.tenant_id;
      setAbility(defineAbilitiesFor(actionObjects));
      setTenantId(fetchedTenantId);
      setPrivilegesFetched(true);
    },
  });
  const [updateToken, { loading }] = useMutation(UPDATE_TOKEN, {
    onError: (error) => {
      console.log("error", error.message);
    },
    onCompleted: () => {
      setAuthorizedUser(true);
      setPrivilegesFetched(false);
      getActiveTenantInfo();
    },
  });
  const [authorizedUser, setAuthorizedUser] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const customTheme = useTheme();
  const [snackbarDetails, setSnackbarDetails] = useState({
    openSnackbar: false,
    severity: "",
    message: "",
  });

  useEffect(() => {
    console.log(" Useeffect of update token ")
    // Function to handle network status changes
    const handleNetworkChange = () => {
      setIsOnline(navigator.onLine);
    };

    // Add event listeners
    window.addEventListener("online", handleNetworkChange);
    window.addEventListener("offline", handleNetworkChange);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("online", handleNetworkChange);
      window.removeEventListener("offline", handleNetworkChange);
    };
  }, []);

  useEffect(() => {
    if (result?.accessToken || updatedToken) {
      updateToken({
        variables: {
          skip: true,
        },
      });
      // setAuthorizedUser(true);

      let existingData = localStorage.getItem("fmcg_info");

      existingData = existingData ? JSON.parse(existingData) : {};

      let currentUser = existingData[result.account.localAccountId];
      // Update the existing data with azure_id
      if (!currentUser) {
        existingData[result.account.localAccountId] = {};
      }
      existingData["active"] = result.account.localAccountId;

      // Save the updated object back to localStorage
      localStorage.setItem("fmcg_info", JSON.stringify(existingData));
    }
  }, [result?.accessToken, result?.account, updateToken, updatedToken]);

  console.log("result", result && result);

  const routeProviderRef = useRef(<RouteProvider />);

  useEffect(() => {
    const handleApolloError = (event) => {
      console.log("handleApolloError()");
      setSnackbarDetails({
        openSnackbar: true,
        severity: constantData.SEVERITY.ERROR,
        message: event.detail,
      });
    };

    window.addEventListener("apollo-error", handleApolloError);

    return () => {
      window.removeEventListener("apollo-error", handleApolloError);
    };
  }, []);

  useEffect(() => {
    const handleNotFound = () => {
      navigate("/not-found", { replace: true });
    };

    window.addEventListener("apollo-not-found", handleNotFound);

    return () => {
      window.removeEventListener("apollo-not-found", handleNotFound);
    };
  }, [navigate]);

  // if (loading) {
  //   return (
  //     <Components.CustomBackdrop
  //       open={loading}
  //       backgroundColor={"rgba(0, 0, 0, 0.20)"}
  //     />
  //   );
  // }

  return (
    <>
      {authorizedUser && (
        <>
          {isOnline ? (
            <>
              <AbilityContext.Provider value={ability}>
                <NotificationProvider
                  tenantId={tenantId}
                  shouldStartSubscription={privilegesFetched}
                >
                  <HeaderComponent result={result && result.account} />
                  <Suspense
                    fallback={
                      <Box
                        sx={(theme) => ({
                          display: theme.display.displayFlex,
                          justifyContent: theme.alignment.justifyContent.center,
                          alignItems: theme.alignment.alignItems.center,
                          height: theme.dimensions.dimen80vh,
                        })}
                      >
                        <CircularProgress thickness={2} size={30} />
                      </Box>
                    }
                  >
                    {routeProviderRef.current}
                  </Suspense>
                </NotificationProvider>
              </AbilityContext.Provider>
            </>
          ) : (
            <Stack
              spacing={2}
              sx={(theme) => ({
                marginTop: theme.dimensions.percent.dimen10,
                padding: theme.dimensions.dimen25,
                alignItems: theme.alignment.alignItems.center,
              })}
            >
              <WifiOffIcon
                sx={{ fontSize: customTheme.size.fontSize.fontSize60 }}
              />
              <Typography variant={constantData.TYPOGRAPHY_VARIANT.SEMI_BOLD}>
                Oops! Something went wrong.
              </Typography>
              <Stack
                sx={(theme) => ({
                  margin: theme.dimensions.dimen25,
                  alignItems: theme.alignment.alignItems.center,
                })}
              >
                <Typography
                  variant={constantData.TYPOGRAPHY_VARIANT.BODY_MEDIUM}
                >
                  It seems you are offline.
                </Typography>
                <Typography
                  variant={constantData.TYPOGRAPHY_VARIANT.BODY_MEDIUM}
                >
                  Please check your network connection.
                </Typography>
              </Stack>
            </Stack>
          )}
          <Components.CustomSnackbar
            openSnackbar={snackbarDetails.openSnackbar}
            message={snackbarDetails.message}
            severity={snackbarDetails.severity}
            setOpenSnackbar={setSnackbarDetails}
          />
        </>
      )}
    </>
  );
};
export default UpdateToken;
